module.exports = __webpack_public_path__ + "img/symbol_2.e250ed4d.png";